export default {"src":"/_next/static/media/money.eb50994b.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};